import { reviewList } from "@/mocks/chigua";

export default function Reviews() {
  return (
    <section id="about" className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-800">
            <i className="ri-heart-fill" aria-hidden="true"></i> 围观点赞
          </p>
          <h2 className="mt-3 font-display text-3xl text-foreground-900 md:text-4xl">
            吃瓜群众的真实口碑
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            一群爱看热闹、也讲道理的围观群众,在这里分享他们的吃瓜体验
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {reviewList.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-2xl border border-secondary-200 bg-background-50 p-6 transition hover:border-accent-300 hover:bg-white"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={`${r.name}的头像`}
                  loading="lazy"
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}